<div class="full-page bg-primary w-100">
  <div class="col-12 register-panel">
    <div class="overflow-hidden p-0">
      <div class="row">
        <div class="col-lg-6 d-none d-lg-block login-banner"></div>
        <div class="user-login-panel col-lg-6 col-12 text-start bg-white">
          <div class="container h-100">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      <div class="font-size-16 fw-bolder text-center mb-2 text-white d-block d-lg-none">DOWNLOAD CLUB APP</div>
      <div class="apple-google-logos d-flex justify-content-center d-lg-none">
        <a href="https://apps.apple.com/gb/app/mlb-ballpark/id513135722" target="_blank"
          ><img src="assets/images/login-registration/apple-link-logo.png"
        /></a>
        <a href="https://play.google.com/store/apps/details?id=com.bamnetworks.mobile.android.ballpark&hl=en_GB" target="_blank"
          ><img src="assets/images/login-registration/google-link-logo.png"
        /></a>
      </div>
    </div>
  </div>
</div>
